import React from 'react'
import { Column } from '@/components/Table'
import {
  NotificationDetail,
  NotificationLevel,
  NotificationType,
} from '@/types'
import { Row, CatTag, LevelTag, levelLetter, OrgTagIcon } from './components'
import Text from '@/components/Text'
import { defaultText, leastText } from '@/constant'
import { ImageIcon } from '@/icon'

export const notificationColumns: (
  type: NotificationType
) => Column<NotificationDetail>[] = (type) => {
  const templateColumn: Column<NotificationDetail>[] = [
    {
      id: 'simple_text',
      label: '消息',
      ellipsis: true,
      format: ({ row, value }) => {
        const color = row?.read_status === 1 ? defaultText : leastText
        return (
          <Row sx={{ gap: '8px', alignItems: 'center' }}>
            <Text
              size='xs'
              weight='regular'
              sx={{
                display: 'flex',
                alignItems: 'center',
                color,
                gap: '8px',
                width: '100%',
              }}
              title={value as string}
            >
              {row?.logo_url && (
                <ImageIcon
                  src={row?.logo_url}
                  sx={{ width: '24px', minWidth: '24px' }}
                />
              )}
              <Text
                size='xs'
                weight='regular'
                sx={{
                  display: 'inline-block',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  color,
                }}
              >
                {value as string}
              </Text>
            </Text>
          </Row>
        )
      },
    },
    {
      id: 'level',
      label: '',
      width: 60,
      // @ts-ignore
      format: ({
        value,
      }: {
        row: NotificationDetail;
        value: NotificationLevel;
      }) => {
        return <LevelTag level={value}>{levelLetter[value]}</LevelTag>
      },
    },
    {
      id: 'org_name',
      label: '',
      width: 160,
      ellipsis: true,
      // @ts-ignore
      format: ({ value }: { row: NotificationDetail; value: string }) => {
        return value ? (
          <Row sx={{ gap: '8px', alignItems: 'center' }}>
            <OrgTagIcon />
            <Text
              size='xs'
              sx={{
                color: leastText,
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
              }}
            >
              {value}
            </Text>
          </Row>
        ) : (
          '该空间已解散'
        )
      },
    },

    {
      id: 'created_at',
      label: '消息时间',
      width: 200,
    },
  ]
  if (type === 'app') {
    const columns: Column<NotificationDetail>[] = [...templateColumn]
    columns?.splice(columns?.length - 1, 0, {
      id: 'tags',
      label: 'Tags',
      width: 200,
      // @ts-ignore
      format: ({
        value,
      }: {
        row: NotificationDetail;
        value: {
          id: number;
          name: string;
        }[];
      }) => {
        return (
          <Row sx={{ gap: '8px', flexWrap: 'wrap' }}>
            {value?.map((item) => (
              <CatTag key={item?.id}>{item.name}</CatTag>
            ))}
          </Row>
        )
      },
    })
    return columns
  }
  return templateColumn
}
